import * as React from 'react';
import HighlightPreferredStoreContainer from '../../components/HighlightPreferredStore/HighlightPreferredStoreContainer.js';
import StoreFinderContainer from '../../components/StoreFinder/StoreFinderContainer.js';
import '../../context/StoreFinder/context.js';
import { StoreFinderProvider } from '../../context/StoreFinder/provider.js';
import '../../context/StoreFinderSlots/context.js';

const StoresRoot = ({ urls , googleMapsId , hidePhone , hideEmail , storeSearchFilters , stores ,  })=>{
    return /*#__PURE__*/ React.createElement(StoreFinderProvider, {
        googleMapsId: googleMapsId,
        withUrlParams: true,
        hidePhone: hidePhone,
        hideEmail: hideEmail,
        initialStores: stores,
        urls: urls
    }, /*#__PURE__*/ React.createElement("style", {
        jsx: true,
        global: true
    }, `
        .banner,
        .notification-bar {
          position: relative;
          z-index: 100;
        }
      `), /*#__PURE__*/ React.createElement(StoreFinderContainer, {
        highlightPreferredStore: /*#__PURE__*/ React.createElement(HighlightPreferredStoreContainer, null),
        storeSearchFilters: storeSearchFilters,
        showAttributesAsTags: true
    }));
};

export { StoresRoot as default };
//# sourceMappingURL=StoresRoot.js.map
